var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import FlexSection from '@marketing/components/sections/FlexSection';
import BlogTile from '@marketing/components/sections/non_product/Blog/BlogTile';
import Pagination from '@marketing/components/sections/non_product/Pagination';
function Listing(_a) {
    var _b = _a.currentPageIndex, currentPageIndex = _b === void 0 ? 1 : _b, _c = _a.articles, articles = _c === void 0 ? [] : _c, pageCount = _a.pageCount, onPageChange = _a.onPageChange;
    var paddingStyle = 'px-2xs-m pt-sm-gutter pb-lg-gutter md:px-3xl-gutter md:pt-xl-m md:pb-4xl-m';
    return (_jsxs(FlexSection, __assign({ paddingStyle: paddingStyle, gapStyle: "gap-xl-m", backgroundColorStyle: "bg-surface-beige", className: "md:!flex-col" }, { children: [_jsx("div", __assign({ className: "grid grid-cols-1 gap-xs-m md:grid-cols-[repeat(2,328px)] lg:grid-cols-[repeat(3,328px)] auto-cols-" }, { children: articles.map(function (article, index) { return (_jsx(BlogTile, { blogPostData: article }, index)); }) })), _jsx("div", __assign({ className: "w-full md:w-[344px]" }, { children: _jsx(Pagination, { pageCount: pageCount, currentPageIndex: currentPageIndex, onPageChange: onPageChange, theme: "light" }) }))] })));
}
export default Listing;
